import React from 'react';

// Component for the steps navigation bar
function StepsNav({ currentStepName, steps }) {
    // Use the passed steps array, or fallback to empty array if not provided
    const stepList = Array.isArray(steps) ? steps : [];
    const currentStepIndex = stepList.indexOf(currentStepName);

    return (
        <div className="container-fluid bg-white p-1 border-bottom fixed-steps-nav">
            <div className="steps-container">
                {stepList.map((stepName, index) => {
                    let stepClass = 'step';
                    let circleClass = 'circle';

                    if (index < currentStepIndex) {
                        stepClass += ' completed';
                        circleClass += ' completed';
                    } else if (index === currentStepIndex) {
                        stepClass += ' active';
                        circleClass += ' active';
                    }

                    return (
                        <div className={stepClass} key={stepName}>
                            <div className={circleClass}></div>
                            <div className="step-label">{stepName}</div>
                        </div>
                    );
                })}
            </div>
        </div>
    );
};
export default StepsNav;